import { Component, OnInit, EventEmitter, Output, Inject } from "@angular/core";
import { Device } from "../../devices/device.model";
import { Alert, AlertInstance } from "../alerts.model";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { AlertsMap, AlertType } from "../../../shared/constants";
import { SessionStateService } from "../../../core/services/session-state.service";
import { Router } from "@angular/router";
import { DevicesService } from "../../devices/devices.service";
import { DeviceType } from "../../devices/devices.constant";
import { SharedUtils } from "../../../shared/shared.utils";
import { AlertsService } from "../alerts.service";

@Component({
  selector: "app-alerts-create-dialog",
  templateUrl: "./alerts-create-dialog.component.html",
  styleUrls: ["./alerts-create-dialog.component.scss"],
})
export class AlertsCreateDialogComponent implements OnInit {
  SharedUtils = SharedUtils;
  changed = false;
  loaded = false;

  alerts = new Array<any>();
  alertsToAdd = new Array<any>();
  alertsToUpdate = new Array<any>();
  alertsToDelete = new Array<any>();
  budgetValue;

  nAssociated: number;
  name: string;
  type: string;
  status: boolean;
  devices = [];

  public exceedingValues = [
    { id: 10, name: "10% increase" },
    { id: 20, name: "20% increase" },
    { id: 30, name: "30% increase" },
    { id: 40, name: "40% increase" },
    { id: 50, name: "50% increase" },
  ];

  public analyzesPeriodValues = [
    { id: 6, name: "6 hours" },
    { id: 12, name: "12 hours" },
    { id: 24, name: "24 hours" },
  ];

  @Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private sessionStateService: SessionStateService,
    private router: Router,
    private devicesService: DevicesService,
    private alertsService: AlertsService,
    public dialogRef: MatDialogRef<AlertsCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.alerts = data.alert;
    this.name = data.name;
    this.type = data.type;
    this.status = data.status;
    this.budgetValue = data.value;
  }

  ngOnInit() {
    this.nAssociated = this.alerts.length;
    this.loadDevices();
  }

  onCloseDialog() {
    this.resetAlertsCache();
    this.dialogRef.close();
  }

  getDevices() {
    return this.devices.filter(
      (dev) => dev.getConnectivityState() !== "offline"
    );
  }

  getInactiveDevices() {
    return this.devices.filter(
      (dev) => dev.getConnectivityState() === "offline"
    );
  }

  isAlertEnabled() {
    return true;
  }

  resetAlertsCache() {
    this.alertsToAdd = [];
    this.alertsToUpdate = [];
  }

  getAlertDevice(pkid: number) {
    const alert = this.alerts.filter(
      (a) => a["alertParameters"]["moduleId"] === pkid
    );
    return alert[0];
  }

  loadDevices() {
    if (this.type === "noConsumptionByFridge") {
      this.devicesService
        .getHouseModules(
          this.sessionStateService.getHouse().houseId,
          DeviceType.CONSUMPTION,
          "REFRIGERATION"
        )
        .subscribe(
          (devices) => {
            this.devices = devices;
            this.loaded = true;
          },
          (err) => {
            this.loaded = true;
          }
        );
    } else if (
      this.type === "consumptionOutsideEconomicPeriod" ||
      this.type === "significantConsumptionIncrease"
    ) {
      this.devicesService
        .getHouseModules(
          this.sessionStateService.getHouse().houseId,
          DeviceType.CONSUMPTION
        )
        .subscribe(
          (devices) => {
            this.devices = devices;
            this.loaded = true;
          },
          (err) => {
            this.loaded = true;
          }
        );
    }
  }

  changeDeviceState(moduleId, deviceId) {
    if (this.inQueueToDelete(moduleId)) {
      this.alertsToDelete = this.alertsToDelete.filter(
        (toDeleteId) => toDeleteId !== moduleId
      );
      this.addAlert(deviceId, moduleId);
    } else if (!this.getAlertDevice(moduleId) && !this.inQueueToAdd(moduleId)) {
      this.addAlert(deviceId, moduleId);
    } else if (this.inQueueToAdd(moduleId)) {
      this.alertsToAdd = this.alertsToAdd.filter(
        (alert) => alert["alertParameters"]["moduleId"] !== moduleId
      );
    } else if (this.getAlertDevice(moduleId)) {
      const toRemoveId = this.alerts.filter(
        (alert) => alert["alertParameters"]["moduleId"] === moduleId
      );
      this.alertsToDelete.push(toRemoveId[0]["alertParameters"]["moduleId"]);
    }
  }

  addAlert(deviceId, moduleId) {
    let val;
    const param = this.getParam();
    /** Default values */
    if (param === "analysisPeriod") {
      val = 6 * 3600;
    } else if (param === "consumptionIncrease") {
      val = 10;
    }

    const alert = {
      deviceId: deviceId,
      alertParameters: {
        moduleId: moduleId,
        conditions: {
          [param]: val,
        },
      },
    };
    this.alertsToAdd.push(alert);
  }

  changeValue(
    moduleId: string,
    deviceId: string,
    param: string,
    value: number
  ) {
    this.changed = true;
    if (this.type === "noConsumptionByFridge") {
      value = value * 3600;
    }
    const specificAlert = this.alerts.filter(
      (alert) => alert["alertParameters"]["moduleId"] === moduleId
    );
    if (specificAlert.length > 0) {
      specificAlert[0]["alertParameters"]["conditions"][param] = value;
      const alertId: any = this.alerts
        .filter(
          (alertSearch) =>
            alertSearch["alertParameters"]["moduleId"] === moduleId
        )
        .map((alertSearch) => alertSearch["alertId"]);
      const alertUpdate = {
        alertId: alertId[0],
        alertParameters: {
          moduleId: moduleId,
          conditions: {
            [param]: value,
          },
        },
      };
      /** To Update */
      this.alertsToUpdate.push(alertUpdate);
    } else {
      const inQueue = this.alertsToAdd.filter(
        (alert) => alert["alertParameters"]["moduleId"] === moduleId
      );
      if (inQueue.length > 0) {
        inQueue[0]["alertParameters"]["conditions"][param] = value;
      } else {
        const alert = {
          deviceId: deviceId,
          alertParameters: {
            moduleId: moduleId,
            conditions: {
              [param]: value,
            },
          },
        };
        /**To Add */
        this.alertsToAdd.push(alert);
      }
    }
  }

  changeCheck(moduleId, deviceId) {
    if (this.type === "consumptionOutsideEconomicPeriod") {
      if (this.getAlertDevice(moduleId)) {
        /** Remove */
        const toRemoveId = this.alerts.filter(
          (alert) => alert["alertParameters"]["moduleId"] === moduleId
        );
        this.alertsService
          .deleteConsumptionOutsideEconomicPeriod(toRemoveId[0]["alertId"])
          .subscribe((res) => {
            this.alerts = this.alerts.filter(
              (alert) => alert["alertParameters"]["moduleId"] !== moduleId
            );
          });
      } else {
        /** To Add */
        const alert = {
          deviceId: deviceId,
          alertParameters: {
            moduleId: moduleId,
          },
        };
        this.alertsToAdd.push(alert);
      }
    }
  }

  inQueueToAdd(moduleId) {
    return (
      this.alertsToAdd.filter(
        (alert) => alert["alertParameters"]["moduleId"] === moduleId
      ).length > 0
    );
  }

  inQueueToDelete(moduleId) {
    return (
      this.alertsToDelete.filter((alertId) => alertId === moduleId).length > 0
    );
  }

  getParam(): string {
    if (this.type === "noConsumptionByFridge") {
      return "analysisPeriod";
    } else if (this.type === "significantConsumptionIncrease") {
      return "consumptionIncrease";
    }
  }

  onSave() {
    if (this.type === "budgetControl") {
      this.alertsService
        .updateBudgetControl(this.status, this.budgetValue)
        .subscribe((res) => {
          this.action.emit(true);
        });
    } else if (this.type === "consumptionOutsideEconomicPeriod") {
      /** Add */
      this.alertsToAdd.forEach((alert) => {
        this.alertsService
          .addConsumptionOutsideEconomicPeriod(alert.alertParameters.moduleId)
          .subscribe((res) => {
            this.alerts.push(alert);
            this.action.emit(true);
          });
      });
      /** Delete */
      this.alertsToDelete.forEach((moduleId) => {
        const toRemove = this.alerts.filter(
          (alert) => alert["alertParameters"]["moduleId"] === moduleId
        );
        this.alertsService
          .deleteConsumptionOutsideEconomicPeriod(toRemove[0]["alertId"])
          .subscribe((res) => {
            this.alerts = this.alerts.filter(
              (alert) => alert["alertParameters"]["moduleId"] !== moduleId
            );
            this.action.emit(true);
          });
      });
    } else {
      /** Delete */
      this.alertsToDelete.forEach((moduleId) => {
        const toRemove = this.alerts.filter(
          (alert) => alert["alertParameters"]["moduleId"] === moduleId
        );
        if (this.type === "noConsumptionByFridge") {
          this.alertsService
            .deleteNoConsumptionByFridge(toRemove[0]["alertId"])
            .subscribe((res) => {
              this.alerts = this.alerts.filter(
                (alert) => alert["alertParameters"]["moduleId"] !== moduleId
              );
              this.action.emit(true);
            });
        } else if (this.type === "significantConsumptionIncrease") {
          this.alertsService
            .deleteSignificantConsumptionIncrease(toRemove[0]["alertId"])
            .subscribe((res) => {
              this.alerts = this.alerts.filter(
                (alert) => alert["alertParameters"]["moduleId"] !== moduleId
              );
              this.action.emit(true);
            });
        }
      });
      /** Add */
      this.alertsToAdd.forEach((alert) => {
        if (this.type === "noConsumptionByFridge") {
          this.alertsService
            .addNoConsumptionByFridge(
              alert.alertParameters.moduleId,
              alert.alertParameters.conditions[this.getParam()]
            )
            .subscribe((res) => {
              this.alerts.push(alert);
              this.action.emit(true);
            });
        } else if (this.type === "significantConsumptionIncrease") {
          this.alertsService
            .addSignificantConsumptionIncrease(
              alert.alertParameters.moduleId,
              alert.alertParameters.conditions[this.getParam()]
            )
            .subscribe((res) => {
              this.alerts.push(alert);
              this.action.emit(true);
            });
        }
      });
      /** Update */
      this.alertsToUpdate.forEach((alert) => {
        if (this.type === "noConsumptionByFridge") {
          this.alertsService
            .updateNoConsumptionByFridge(
              alert["alertId"],
              alert["alertParameters"]["moduleId"],
              alert["alertParameters"]["conditions"][this.getParam()]
            )
            .subscribe((res) => {
              this.action.emit(true);
            });
        } else if (this.type === "significantConsumptionIncrease") {
          this.alertsService
            .updateSignificantConsumptionIncrease(
              alert["alertId"],
              alert["alertParameters"]["moduleId"],
              alert["alertParameters"]["conditions"][this.getParam()]
            )
            .subscribe((res) => {
              this.action.emit(true);
            });
        }
      });
      // Reset Cache
      this.resetAlertsCache();
    }
    this.onCloseDialog();
  }

  goToDevices() {
    this.onCloseDialog();
    this.router.navigate(["/devices"], {
      queryParams: { deviceType: "consumption" },
    });
  }

  getNoProductionToolTip() {
    // tslint:disable-next-line:max-line-length
    return "If your solar energy system stops producing energy on the last 24 hours, you will be immediately warned. This alert helps you detecting possible anomalies and/or maintenance needs of your photovoltaic system, thus ensuring its maximum efficiency.";
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/alerts/alerts-create-dialog/alerts-create-dialog.component.ts